
import { parseISO, parse, format, isValid } from 'date-fns'

export default {
    props: {
        value: {
            type: null,
            default: null,
        },
        classes: {
            type: String,
            default: '',
        },
        hint: {
            type: String,
            default: undefined,
        },
        time: Boolean,
        hidden: Boolean,
        xl: Boolean,
        sm: Boolean,
        xs: Boolean,
        xss: Boolean,
        placeholder: {
            type: String,
            default: undefined,
        }
    },

    data() {
        return {
            error: false,
            dateValue: null,
            timeValue: null,
        }
    },

    computed: {
        id() {
            return `input-date-${this._uid}`
        },
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (value) {
                    const dateTime = parseISO(value)
                    if (isValid(dateTime)) {
                        this.error = false
                        this.dateValue = format(dateTime, 'yyyy-MM-dd')
                        this.timeValue = format(dateTime, 'HH:mm')
                        return
                    }
                }
                this.error = false
                this.dateValue = null
                this.timeValue = null
            },
        },

        error(e) {
            if (e) this.$emit('valid', false)
            else this.$emit('valid', true)
        },
    },

    methods: {
        onInputDate(e) {
            if (this.timeValue) this.sendResponse(parseISO(`${e} ${this.timeValue}`))
            else this.sendResponse(parseISO(`${e}`))
        },

        onInputTime(e) {
            this.sendResponse(parseISO(`${this.dateValue} ${e}`))
        },

        sendResponse(dateTime) {
            if (dateTime && isValid(dateTime)) {
                this.error = false
                this.$emit('valid', true)
                this.$emit('input', dateTime)
            } else {
                if (dateTime) this.error = true
                this.$emit('input', null)
            }
        },

        onBlur(e) {
            this.$emit('blur', e)
        },
    },
}
